<ng-template #content let-modal>
  

  <div class="common-header-flex">
    <div>{{title}}</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>  

  <div class="modal-body">
    <div class="row"> 

      <ng-content select="[planCards]"></ng-content>  

      <div class="container-md " style="text-align: end; margin-bottom: 3rem;" *ngIf="isPlanExceed()">
        <span class="alert-danger" style="padding: 6px;border-radius: 5px;">Plan limit exceeds</span>
      </div>

      <div class="col-sm-12" *ngIf="!editMode">

        <input (keyup)="onSlotSearch(slotSearch.value)" #slotSearch type="text" placeholder="Search by user name or email"
        class="searchBox form-control">

      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 mt-4 manage-container" 
        [formGroup]="slotForm"
        infiniteScroll [infiniteScrollDistance]="1" 
        [scrollWindow]="false"  
        [alwaysCallback]="true"
        [infiniteScrollThrottle]="500" 
        (scrolled)="onScrollDown()" >
 
        <ng-container formArrayName="users">

          <table *ngIf="slotArray?.controls?.length > 0; else noData">
            
            <tr class="manage-body">
              <th *ngIf="!editMode"></th>
              <ng-content select="[header]"></ng-content>
            </tr>

            <ng-container *ngFor="let slot of slotArray?.controls; let i = index">
              <tr [formGroupName]="i">

                <td *ngIf="!editMode"><input type="checkbox" formControlName="checked"
                    (change)="onCheck($event.target.checked , slot.get('userId').value , i)">
                </td>

                <td class="slot-name-cell">
                  <div style="display: flex; align-items: center;gap: 5px;">
                    <span [style.cursor]="!editMode ? 'pointer' : 'default'" (click)="!editMode && toggleCheckbox(i)">
                      {{slot.get('name').value}}
                    </span>
                    <span *ngIf="slot.get('superAdmin')?.value === true">
                      <ng-icon name="tablerCrown" class="crown cu-crown-icon"></ng-icon>
                    </span>
                  </div>
                </td>

                <td>{{slot.get('email').value}}</td>
                
                <!-- for job slot screen  -->
                <ng-container *ngIf="isJobSlot">
                  <td colspan="2">
                    <section class="slot-td">
                      <div class="w-50 slot-input-cell">
                        <input class="form-control" type="text" placeholder="Enter slots here" formControlName="slotValue"
                          (keyup)="onChange(slot?.get('userId')?.value , $event , i)" (keypress)="restrictSymbols($event)">
                        <ng-container *ngIf="(slot?.get('slotValue')?.touched || slot?.get('slotValue')?.dirty)
                                                          && slot?.get('slotValue')?.invalid">
                          <div class="text-danger" *ngIf="slot?.get('slotValue')?.errors?.required">
                            Slots required
                          </div>
                          <div class="text-danger"
                            *ngIf="!slot?.get('slotValue')?.errors?.required && slot?.get('slotValue')?.errors?.lessThanUsed">
                            Slots cannot be less than utilized
                          </div>
                        </ng-container>
                      </div>
                      <div class="used">{{slot.get('slotUtilized').value}}</div>
                    </section>
                  </td>
                  <td colspan="2">
                    <section class="slot-td">
                      <div class="w-50 slot-input-cell">
                        <input class="form-control" type="text" placeholder="Enter slots here" formControlName="featuredValue"
                          (keyup)="onChange(slot?.get('userId')?.value , $event , i , 'FEATURED')" (keypress)="restrictSymbols($event)">
                        <ng-container *ngIf="(slot?.get('featuredValue')?.touched || slot?.get('featuredValue')?.dirty)
                                                          && slot?.get('featuredValue')?.invalid">
                          <div class="text-danger" *ngIf="slot?.get('featuredValue')?.errors?.required">
                            Slots required
                          </div>
                          <div class="text-danger"
                            *ngIf="!slot?.get('featuredValue')?.errors?.required && slot?.get('featuredValue')?.errors?.lessThanUsed">
                            Slots cannot be less than utilized
                          </div>
                        </ng-container>
                      </div>
                      <div class="used">{{slot.get('featuredUtilized').value}}</div>
                    </section>
                  </td> 
                </ng-container>
                
                <!-- for interaction screen  -->
                <ng-container *ngIf="!isJobSlot">
                  <td>{{slot.get('userType').value | MTAPipe: 'convertMTA' }}</td>
                  <td>{{slot.get('slotAllocated').value}}</td>
                  <td>{{slot.get('slotUtilized').value}}</td> 
                  <td>
                    <div class="slot-input-cell">
                      <input class="form-control" type="text" placeholder="Enter slots here" formControlName="slotValue"
                        (keyup)="onChange(slot?.get('userId')?.value , $event , i)" (keypress)="restrictSymbols($event)">
                      <ng-container *ngIf="(slot?.get('slotValue')?.touched || slot?.get('slotValue')?.dirty)
                                                        && slot?.get('slotValue')?.invalid">
                        <div class="text-danger" *ngIf="slot?.get('slotValue')?.errors?.required">
                          Slots required
                        </div>
                        <div class="text-danger"
                          *ngIf="!slot?.get('slotValue')?.errors?.required && slot?.get('slotValue')?.errors?.lessThanUsed">
                          Slots cannot be less than utilized
                        </div>
                      </ng-container>
                    </div>
                  </td>
                </ng-container> 


              </tr>
            </ng-container>

          </table>

          <ng-template #noData>
              <span style="margin-top: 4rem;">No data available to display</span>
          </ng-template>

          <div class="col-lg-12 text-center mt-1 gs-end-of-list" *ngIf="superObj?.stopScroll && slotArray?.controls?.length >= 9">
            <div class="col-md-12">
             <ng-icon name="tablerCircleCheck"></ng-icon>
             </div>
            <div class="col-md-12">
              <p class="biase">You've reached the bottom of the page</p>
            </div>
          </div>

        </ng-container>

      </div> 

    </div>  
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-default w70" (click)="closeModal()">Cancel</button>
    <button #slotButton1 *ngIf="!editMode" [disabled]="!isAnyoneChecked()  || slotForm.invalid || isPlanExceed()" type="button" class="btn btn-primary w70"
      (click)="manageSlot()">Save</button>
    <button #slotButton2 *ngIf="editMode" [disabled]="slotForm.invalid || isPlanExceed()" type="button" class="btn btn-primary w70"
      (click)="manageSlot()">Save</button>
  </div>

</ng-template>